import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';

// Extension to handle {{survey.link}} replacement
export const SurveyLinkReplacement = Extension.create({
  name: 'surveyLinkReplacement',

  addOptions() {
    return {
      initialSurveyId: null,
    };
  },

  addProseMirrorPlugins() {
    const initialSurveyId = this.options.initialSurveyId;

    return [
      new Plugin({
        key: new PluginKey('surveyLinkReplacement'),

        state: {
          init() {
            return DecorationSet.empty;
          },
          apply(tr, oldDecoSet) {
            return oldDecoSet.map(tr.mapping, tr.doc);
          },
        },

        appendTransaction(transactions, oldState, newState) {
          const docChanged = transactions.some((tr) => tr.docChanged);
          if (!docChanged) return null;

          const { doc, tr } = newState;

          // Collect every match against the untouched doc first. Editing inside
          // the walk shifted the doc under it — `{{survey.link}}` is 15 chars and
          // the node replacing it is 1 — so every later position was off by 14
          // and eventually ran past the end ("Position N out of range").
          const matches = [];
          doc.descendants((node, pos) => {
            if (!node.isText) return;
            const text = node.text || '';
            const regex = /\{\{survey\.link\}\}/g;
            let match;
            while ((match = regex.exec(text)) !== null) {
              matches.push({
                from: pos + match.index,
                to: pos + match.index + match[0].length,
              });
            }
          });

          if (matches.length === 0) return null;

          // Last match first, so each replacement leaves the earlier offsets valid.
          for (let i = matches.length - 1; i >= 0; i--) {
            const { from, to } = matches[i];
            tr.replaceWith(
              from,
              to,
              newState.schema.nodes.surveySelect.create({
                surveyId: initialSurveyId ?? null,
              })
            );
          }

          return tr;
        },
      }),
    ];
  },
});
